import { Box } from '@mui/material';
import {
  AutoComplete,
  SnackbarApiErrorMessage,
  useDataProvider,
  useSnackbar,
} from '@ui-framework/index';
import { useEffect, useState, forwardRef } from 'react';

const ServiceProviderContact = forwardRef(
  ({ field, serviceProviderId, locationId, onChange, ...props }, ref) => {
    const snackbar = useSnackbar();
    const [value, setValue] = useState(null);

    const provider =
      process.env.NODE_ENV === 'development' ? 'sxclServices' : 'default';
    const { get, getApiUrl } = useDataProvider(provider);

    const [defaultOptions, setDefaultOptions] = useState([]);

    const getContactDisplay = item => {
      if (!item?.firstName) return '/';
      const {
        firstName = '',
        lastName = '',
        email = '',
        phoneNumber = '',
      } = item;
      return [`${firstName} ${lastName}`.trim(), email, phoneNumber].join(
        ' / ',
      );
    };

    const getContacts = async search => {
      const apiPath = `/sxcl/v1/users?companyId=${serviceProviderId}&${search}&enabled=true`;
      const result = await get(`${getApiUrl()}${apiPath}`);
      if (result.ok) {
        const contactOptions =
          result?.data?.data?.map(item => ({
            label: getContactDisplay(item),
            value: JSON.stringify(item),
          })) || [];
        return contactOptions;
      }
      snackbar.showMessage({
        type: 'error',
        data: <SnackbarApiErrorMessage errors={result?.errors} />,
      });
      return null;
    };

    const loadOptions = async (searchValue, callback) => {
      if (!searchValue || searchValue.length < 2) return [];
      const resultsData = await getContacts('limit=50');
      if (resultsData) {
        return callback(resultsData);
      }
      return callback([]);
    };

    const initialLoad = async () => {
      const result = await getContacts('limit=50');
      setDefaultOptions([...result]);
    };

    useEffect(() => {
      initialLoad();
    }, []);

    return (
      <Box>
        <AutoComplete
          ref={ref}
          defaultOptions={defaultOptions}
          loadOptions={loadOptions}
          {...props}
          isClearable
          inPopUp
          overwriteProps={{
            value,
            onChange: d => {
              setValue(d);
              onChange(d);
            },
          }}
        />
      </Box>
    );
  },
);

export default ServiceProviderContact;
